import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/axios'
Vue.use(Vuex)

const TransferStore = new Vuex.Store({
    state: {
        listtransfer : [],
    },
    mutations: {
        setlisttransfer(state, listtransfer) {
            state.listtransfer = listtransfer
        },
    },
    actions: {
        async getlisttransfer(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/user/transfer",options,{headers : {'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'}}).then((r) => {
                return r.data
            })
            context.commit("setlisttransfer", data)
        },
    }
})

export default TransferStore

